export const auth = {
  namespaced: true,
  state: {
    user: null,
    userProfile: '',
    redirectUrl: '',
  },
  getters: {
    isLogined(state) {
      return state.user !== null
    },
    getRedirectUrl(state) {
      return state.redirectUrl
    },
  },
  // Sync process only
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUserProfile(state, profile) {
      state.userProfile = profile
    },
    setRedirectUrl(state, url) {
      state.redirectUrl = url
    },
  },
  // Async process, External API linkage
  actions: {},
}
